<script lang="ts">
import { defineComponent, PropType } from 'vue';

import ThemedButton from '@/components/base/ThemedButton.vue';
import { NutsLineItem } from '@/lib/cart/lineItem';

export default defineComponent({
  name: 'CountryRestrictedItemsNotification',
  props: {
    allRestricted: { required: false, type: Boolean, default: false },
    restrictedItems: { required: false, type: Array as PropType<NutsLineItem[]> },
  },
  components: {
    ThemedButton,
  },
  setup(_, { emit }) {
    return {
      handleRemove: () => emit('remove-items'),
      infoIcon: nutshell['img/info.svg'],
    };
  },
});
</script>

<template>
  <div class="p-4 border border-gray-200 border-solid md:py-6 rounded-2xl">
    <div class="flex items-start">
      <img :src="infoIcon" alt="info icon" class="mr-4" />
      <div class="text-sm font-bold leading-5 md:text-base">
        Uh-oh! Some of your items are restricted for import to Canada.
      </div>
    </div>
    <ul class="mt-2 list-disc list-inside">
      <li v-for="item in restrictedItems" :key="item.id" class="mt-1 text-sm">
        {{ item.name.en }}
        <template v-if="item.variant.variantName"> ({{ item.variant.variantName.en }}) </template>
      </li>
    </ul>

    <div v-if="allRestricted" class="mt-2 text-sm font-bold leading-5 md:mt-5 md:text-base">
      Please change your address to continue. We're really sorry, we don't write the rules on this
      stuff!
    </div>
    <slot v-else>
      <div class="mt-2 text-sm font-bold leading-5 md:mt-5 md:text-base">
        You can either change your delivery address or remove these items from your cart
      </div>
      <div class="flex mt-4">
        <ThemedButton
          type="button"
          data-test="restricted-items-remove"
          theme="gray"
          @click="handleRemove"
          fullWidth
        >
          Remove Items
        </ThemedButton>
      </div>
    </slot>
  </div>
</template>
